import { UserProperties, RoleList, EUserRole } from "../types/user.type";
import { capitalizeFirstLetter } from "./text";
import { IHttpResponse, IPayloadPagination } from "./pagination";
import { EEmployeeRole, EEmployeeStatus, EmployeeProperties } from "../types/employee.type";
import axios from "axios";
import { EEmployeeRoleApprovalStatus, EEmployeeRoleStatus } from "../types/employeeRole.type";

export const APP_AUTH_TOKEN = process.env.REACT_APP_ID + "_auth";

export function saveToken(token: string) {
	return localStorage.setItem(APP_AUTH_TOKEN, token);
}

export function getToken() {
	return localStorage.getItem(APP_AUTH_TOKEN);
}

export function removeToken() {
	return localStorage.removeItem(APP_AUTH_TOKEN);
}

export function showRoleName(role: EUserRole) {
	if (RoleList[role]) {
		return RoleList[role];
	} else {
		return String(role)
			.split("_")
			.map((item) => capitalizeFirstLetter(item))
			.join(" ");
	}
}

export const getLoginData = async (token?: string) => {
	const headers = {
		Authorization: "Bearer " + (token ? token : getToken()),
	};
	const resultUser = await axios.get<IHttpResponse<UserProperties>>(process.env.REACT_APP_BASE_URL + "/users/me", {
		headers,
	});

	if (!resultUser?.data?.payload?.userId) {
		return Promise.reject("Unathorized!");
	}

	const resultEmployee = await axios.get<IHttpResponse<IPayloadPagination<EmployeeProperties>>>(
		process.env.REACT_APP_BASE_URL +
			"/employees?filterUserId=" +
			resultUser.data.payload.userId +
			"&filterStatus=ACTIVE" +
			"&filterRoleStatus=" +
			EEmployeeRoleStatus.PUBLISH +
			"," +
			EEmployeeRoleStatus.UNPUBLISH +
			"&includeData=office,currentPositionItem,groupMembers,starAgentPhoto" +
			"&includeNullOffice=true" +
			"&filterRoleApprovalStatus=" +
			EEmployeeRoleApprovalStatus.APPROVED,
		{ headers }
	);

	if (resultEmployee.data.payload.count < 1) {
		throw new Error("Your account maybe disabled by administrator");
	}
	// Here we must handle if user have multi office
	const employees = resultEmployee.data.payload.results;

	const employeesFiltered = employees.filter((employee) => employee.status === EEmployeeStatus.ACTIVE);
	const employee = employeesFiltered[0];
	const roles: EEmployeeRole[] = [];
	employeesFiltered.forEach((employee) => {
		// Block Status: Inactive, Open
		employee.employeeRole
			?.filter((item) => item.status !== EEmployeeRoleStatus.OPEN && item.status !== EEmployeeRoleStatus.INACTIVE)
			.forEach((item) => {
				roles.push(item.role);
			});
	});
	if (!roles) {
		throw new Error("Cannot get user role data, your account maybe not active!");
	}

	return {
		user: {
			...resultUser.data.payload,
			employee: employeesFiltered,
		},
		employees: employeesFiltered,
		employeeId: employee.employeeId,
		officeId: employee.officeId,
		currentPosition: employee.currentPosition,
		roles,
	};
};

export const isEmail = (email: string) => {
	return email.match(
		/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	);
};
